import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { BRAND } from "@/lib/brand";

export default function Footer() {
  const [partnerCount, setPartnerCount] = useState(0);
  useEffect(() => {
    api.get("/stakeholders/count").then((r) => setPartnerCount(r.data?.count || 0)).catch(() => {});
  }, []);
  return (
    <>
      {/* Decorative pattern divider above the footer */}
      <div
        className="h-16 w-full bg-cover bg-center sm:h-20"
        style={{ backgroundImage: `url(${BRAND.divider})`, backgroundRepeat: "repeat-x" }}
        aria-hidden="true"
        data-testid="footer-divider"
      />
      <footer className="border-t border-primary/10 bg-primary text-primary-foreground" data-testid="site-footer">
        <div className="container-page grid gap-10 py-14 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link to="/" className="inline-flex items-center gap-2" data-testid="footer-logo-link">
              <img src="/brand/cbhc-symbol.png" alt="CBHC" className="h-6 w-6 shrink-0 rounded" loading="lazy" decoding="async" />
              <span className="font-display text-2xl font-bold tracking-tight">Black Health Resources</span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-foreground/80">
              Connecting Colorado's Black community with trusted, culturally competent health professionals
              and organizations. A program of the Colorado Black Health Collaborative.
            </p>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-primary-foreground/60">Explore</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/directory" className="hover:text-accent">Directory</Link></li>
              <li><Link to="/#categories" className="hover:text-accent">Categories</Link></li>
              <li><Link to="/blog" className="hover:text-accent">Blog</Link></li>
              <li><Link to="/signup" className="hover:text-accent">List your practice</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-primary-foreground/60">Contact</div>
            <ul className="mt-4 space-y-2 text-sm text-primary-foreground/80">
              <li>info@coloradoblackhealth.org</li>
              <li>(720) 579-2126</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-primary-foreground/10 py-5 text-center text-xs text-primary-foreground/60">
          {partnerCount > 0 && (
            <div className="mb-2 text-[11px] text-primary-foreground/50" data-testid="partner-count">
              Reporting to {partnerCount} community partner{partnerCount === 1 ? "" : "s"} monthly
            </div>
          )}
          © {new Date().getFullYear()} Colorado Black Health Resource Directory. All rights reserved.
        </div>
      </footer>
    </>
  );
}
